import { render, staticRenderFns } from "./ServerErrorComponent.vue?vue&type=template&id=1bdec398&"
import script from "./ServerErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ServerErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports